<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-indigo">
    <mat-icon>print</mat-icon>
  </div>
  <h2>{{ 'ADMIN.ORDER_NUMBER' | translate }} {{ order.transactionId }}</h2>
</div>
<div mat-dialog-content>
  <mat-radio-group [(ngModel)]="selectedType" class="flex flex-col">
    <mat-radio-button [value]="StyleEnum.ORDER_PRODUCTS">
      {{ 'identificationLabels' | translate }}
    </mat-radio-button>
    <mat-radio-button [value]="StyleEnum.PRODUCTION_FILE">
      {{ 'order.confirmClose.print' | translate }}
    </mat-radio-button>
  </mat-radio-group>
</div>
@if (progress) {
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="orderToPrint = this.order" [disabled]="progress">
    <mat-icon>print</mat-icon>
    {{ 'print' | translate }}
  </button>
</div>
@if (selectedType === StyleEnum.ORDER_PRODUCTS) {
  <app-print-order-products [hidden]="true" [order]="orderToPrint" (printed)="print($event)"></app-print-order-products>
} @else {
  <app-print-labels [hidden]="true" [order]="orderToPrint" (printed)="print($event)"></app-print-labels>
}
